import * as z from 'zod';

const months = [
  {
    name: 'January',
    maxDays: 31,
  },
  {
    name: 'February',
    maxDays: 29,
  },
  {
    name: 'March',
    maxDays: 30,
  },
  {
    name: 'April',
    maxDays: 30,
  },
  {
    name: 'May',
    maxDays: 31,
  },
  {
    name: 'June',
    maxDays: 30,
  },
  {
    name: 'July',
    maxDays: 31,
  },
  {
    name: 'August',
    maxDays: 31,
  },
  {
    name: 'September',
    maxDays: 30,
  },
  {
    name: 'October',
    maxDays: 31,
  },
  {
    name: 'November',
    maxDays: 30,
  },
  {
    name: 'December',
    maxDays: 31,
  },
];

export const monthsZod = z.object({
  name: z.string(),
  value: z.string(),
  maxDays: z.number(),
});

type TMonth = z.infer<typeof monthsZod>;

function createMonthOptions() {
  return months.map((m, i) => ({ ...m, value: `${i + 1}` }));
}

const defaultMonth: TMonth = { name: 'None', value: '', maxDays: 0 };

export const monthOptions: TMonth[] = [defaultMonth, ...createMonthOptions()];

export const dayZod = z.object({
  name: z.string(),
  value: z.string(),
});

type TDay = z.infer<typeof dayZod>;

export function createMonthDaysOptions() {
  const days: TDay[] = [{ name: '—', value: '' }];
  for (let i = 0; i < 31; i++) {
    days.push({ name: `${i + 1}`, value: `${i + 1}` });
  }

  return days;
}

export function numberToDay(day: number | null = 0, defaultValue = 0): TDay {
  const daysOptions = createMonthDaysOptions();
  return daysOptions.find((item) => item.value === `${day}`) ?? daysOptions[defaultValue];
}

export function dayToNumber(day: TDay): number | null {
  return day.value ? parseInt(day.value, 10) : null;
}

export function strToMonth(month: number | null = 0, defaultValue = 0): TMonth {
  return monthOptions.find((item) => parseInt(item.value, 10) === month) ?? monthOptions[defaultValue];
}

export function monthToNumber(month: TMonth): number | null {
  return month.value ? parseInt(month.value, 10) : null;
}
